import React from 'react'
import styles from './show-more.module.scss'

export function ShowMore(props: { expanded: boolean }) {
  const content = props.expanded ? '-' : '+'
  return (
    <span className={styles.show_more}>{content}</span>
  )
}